import { Routes } from '@angular/router';

import { AuthService } from '../auth/auth.service';

import { VimeoComponent } from './vimeo.component';

export const VimeoRoutes: Routes = [
    {
        path: 'vimeo',
        canActivate: [AuthService],
        children: [
            { path: '', redirectTo: 'watch', pathMatch: 'full' },
            {
                path: 'watch',
                component: VimeoComponent,
            },
            {
                path: 'video/:playlistItemId',
                component: VimeoComponent,
            },
        ],
    },
];
